import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function ValidationIssue$Companion$$childSerializers$_anonymous__sg83na() {
  return new (ArrayListSerializer())(StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t3l_1 = [lazy(tmp_0, ValidationIssue$Companion$$childSerializers$_anonymous__sg83na), null, null];
      }
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.validation.ValidationIssue', this, 3);
        tmp0_serialDesc.a1b('path', false);
        tmp0_serialDesc.a1b('code', false);
        tmp0_serialDesc.a1b('text', false);
        this.s4y_1 = tmp0_serialDesc;
      }
      t4y(encoder, value) {
        var tmp0_desc = this.s4y_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().t3l_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.u4y_1);
        tmp1_output.v14(tmp0_desc, 1, value.v4y_1);
        tmp1_output.a15(tmp0_desc, 2, value.w4y_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t4y(encoder, value instanceof ValidationIssue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s4y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance().t3l_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.q13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.q13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return ValidationIssue().x4y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.s4y_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance().t3l_1[0].f2(), IntSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ValidationIssueClass;
function ValidationIssue() {
  if (ValidationIssueClass === VOID) {
    class $ {
      toString() {
        return 'ValidationIssue(path=' + toString(this.u4y_1) + ', code=' + this.v4y_1 + ', text=' + this.w4y_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.u4y_1);
        result = imul(result, 31) + this.v4y_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.w4y_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ValidationIssue()))
          return false;
        if (!equals(this.u4y_1, other.u4y_1))
          return false;
        if (!(this.v4y_1 === other.v4y_1))
          return false;
        if (!(this.w4y_1 === other.w4y_1))
          return false;
        return true;
      }
      static x4y(seen0, path, code, text, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance().s4y_1);
        }
        var $this = createThis(this);
        $this.u4y_1 = path;
        $this.v4y_1 = code;
        $this.w4y_1 = text;
        return $this;
      }
    }
    initMetadataForClass($, 'ValidationIssue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    ValidationIssueClass = $;
  }
  return ValidationIssueClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.validation.ValidationIssuePart', this, 2);
        tmp0_serialDesc.a1b('code', false);
        tmp0_serialDesc.a1b('text', false);
        this.y4y_1 = tmp0_serialDesc;
      }
      z4y(encoder, value) {
        var tmp0_desc = this.y4y_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.v14(tmp0_desc, 0, value.a4z_1);
        tmp1_output.a15(tmp0_desc, 1, value.b4z_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z4y(encoder, value instanceof ValidationIssuePart() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.y4y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.q13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.q13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ValidationIssuePart().c4z(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.y4y_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var ValidationIssuePartClass;
function ValidationIssuePart() {
  if (ValidationIssuePartClass === VOID) {
    class $ {
      toString() {
        return 'ValidationIssuePart(code=' + this.a4z_1 + ', text=' + this.b4z_1 + ')';
      }
      hashCode() {
        var result = this.a4z_1;
        result = imul(result, 31) + getStringHashCode(this.b4z_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ValidationIssuePart()))
          return false;
        if (!(this.a4z_1 === other.a4z_1))
          return false;
        if (!(this.b4z_1 === other.b4z_1))
          return false;
        return true;
      }
      static c4z(seen0, code, text, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_0().y4y_1);
        }
        var $this = createThis(this);
        $this.a4z_1 = code;
        $this.b4z_1 = text;
        return $this;
      }
    }
    initMetadataForClass($, 'ValidationIssuePart', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    ValidationIssuePartClass = $;
  }
  return ValidationIssuePartClass;
}
//region block: init
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3o44jbz1kg34s,
  Companion_instance_0 as Companion_instance968c7ignz3xx,
};
//endregion

//# sourceMappingURL=validate.mjs.map
